export default "__VITE_ASSET__BbUpq6aV__"